<template>
  <el-row class="user-sign__search">
    <span>标签名称</span>
    <el-input v-model="searchData.name" clearable placeholder="请输入" style="width: 300px"></el-input>
    <span>分类</span>
    <el-select v-model="searchData.signType" clearable filterable placeholder="请选择">
      <el-option v-for="item in signTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
    </el-select>
    <span>渠道</span>
    <el-select v-model="searchData.channel" clearable filterable placeholder="请选择">
      <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
      </el-option>
    </el-select>
    <span>国家</span>
    <el-select v-model="searchData.countryCode" clearable filterable placeholder="请选择">
      <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country" :value="item.countryCode">
      </el-option>
    </el-select>
    <span>模板</span>
    <el-select v-model="searchData.signTemplate" clearable placeholder="请选择">
      <el-option v-for="item in signTemplateList" :key="item.value" :label="item.name"
        :value="item.value"></el-option>
    </el-select>
    <span>状态</span>
    <el-select v-model="searchData.valid" clearable placeholder="请选择">
      <el-option key="0" label="下线" value="0"> </el-option>
      <el-option key="1" label="上线" value="1"> </el-option>
    </el-select>
    <el-button style="margin-left: 10px" type="primary" @click="handleSearch">查询</el-button>
    <el-button style="margin-top: 10px" type="primary" @click="handleCreate">新建标签</el-button>
  </el-row>
</template>

<script>
export default {
  name: 'SearchForm',
  props: {
    signTypeList: {
      type: Array,
      default: () => []
    },
    channelList: {
      type: Array,
      default: () => []
    },
    countryList: {
      type: Array,
      default: () => []
    },
    signTemplateList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchData: {
        signType: '',
        channel: '',
        countryCode: '',
        signTemplate: '',
        valid: '',
        name: null,
      }
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.searchData)
    },
    handleCreate() {
      this.$emit('create')
    },
    resetSearch() {
      this.searchData = {
        signType: '',
        channel: '',
        countryCode: '',
        signTemplate: '',
        valid: '',
        name: null,
      }
    }
  }
}
</script>

<style scoped lang="scss">
.user-sign__search {
  span {
    font-size: 20px;
    font-weight: 600;
    margin-right: 15px;
    margin-left: 15px;
  }

  .searchBtn {
    margin-left: 10px;
  }
}
</style> 